import { lazy } from 'react';

import CustomLazyLoader from 'routes/CustomLazyLoader';

export const ClientDetails = lazy(() => CustomLazyLoader(
  () => import('modules/client-details/containers/ClientDetails'),
  'ClientDetails'
));

export default ClientDetails; 
